import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { cn } from '@/lib/cn';

type Props = ComponentPropsWithoutRef<'input'>;

export const ContentEditable = forwardRef<HTMLInputElement, Props>(
  (props, ref) => {
    const { className, ...rest } = props;
    return (
      <input
        ref={ref}
        className={cn(
          'w-full text-foreground bg-transparent py-0.5 px-1 selection:bg-blue-500/10 outline-1 outline-transparent focus:outline-blue-400 rounded-sm -outline-offset-1 transition-outline duration-200',
          props.className,
        )}
        {...rest}
      />
    );
  },
);
